import axios from "axios"
import { AD_COPIES_URL } from "src/constants"

//const userId = import.meta.env.VITE_USER_ID
// const userId = localStorage.getItem("userId")

export const updateAdCopy = async (adCopy) => {
   const userId = localStorage.getItem("userId")
   return await axios.post(`${AD_COPIES_URL}/update/${userId}`, adCopy)
}
